<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center px-4">
    <div class="max-w-sm w-full text-center">
      <div class="text-5xl mb-4">🔗</div>
      <h1 class="text-xl font-semibold text-gray-900 mb-2">Link expirado</h1>
      <p class="text-sm text-gray-500">
        Este link de acesso expirou ou é inválido. Solicite um novo link pelo
        seu sistema.
      </p>
    </div>
  </div>
</template>
